import React from 'react';
import { useSelector } from 'react-redux';
import { BoxWrapper } from './CommonPurchase.styles';
import {
  ActionRow,
  DetailGrid,
  DetailItem,
  DocChip,
  DocChips,
  InfoBoxGrid,
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  PrimaryActionButton,
  PrimaryActionLink,
  SectionLabel,
  StatusPill,
} from './InfoBoxV2.styles';
import ProductsTableCard from './ProductsTableCard';
import {
  getDDFDocument,
  guideType,
  primaQuoteTypes,
} from '../../../../constants';
// import MessagesModal from '../../../elements/MessagesModal';
import { downloadFile } from '../../../../../services/axios-client/axeHelpers';
import axe from '../../../../../services/axios-client/axiosClient';
import { apiDownloadDocument } from '../../../../../services/axios-client/axeCommons';
import { isNewBrokerageSystem } from '../../../../helpers/brokerageHelpers';

function InfoBoxAuto({
  insuranceRequest,
  statues,
  quoteStatus,
  // messagesModalData,
  rc_quotation,
  risk_quotations,
}) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const downloadResourceDocs = async (id) => {
    const res = await axe.get(`/download-resource-document/${id}/0`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const downloadPreventive = async () => {
    const res = await axe.get(
      `/quotations/${rc_quotation.id}/preventivo/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  const DDF_document = getDDFDocument(rc_quotation, insuranceRequest);

  const downloadDocument = async (documentId) => {
    if (documentId === undefined) {
      return;
    }
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  // const getTotal = () => {
  //   let rcTotalAmount = 0;
  //   let primaGuaranteesPrices = 0;
  //   let risksTotalAmount = 0;
  //   let servicePrice = 0;

  //   if (
  //     insuranceRequest.insurance_request_extra_services.length > 0
  //   ) {
  //     insuranceRequest.insurance_request_extra_services.forEach((service) => {
  //       servicePrice += parseFloat(calculateExtraServicePrice(rc_quotation, service));
  //     });
  //   }

  //   if (risk_quotations && risk_quotations.length > 0) {
  //     for (let i = 0; i < risk_quotations.length; i++) {
  //       const item = risk_quotations[i];
  //       risksTotalAmount += rc_quotation.payment_frequency === 1 ? parseFloat(item.amount) : parseFloat(item.amount / rc_quotation.payment_frequency);
  //     }
  //   }

  //   if (rc_quotation.company_id === 2) {
  //     rc_quotation.guarantees.forEach((guarantee) => {
  //       primaGuaranteesPrices += rc_quotation.payment_frequency === 1 ? parseFloat(guarantee.amount) : parseFloat(guarantee.amount / rc_quotation.payment_frequency) || 0;
  //     });
  //   }

  //   rcTotalAmount = rc_quotation.payment_frequency === 1 ? parseFloat(rc_quotation.amount) : parseFloat(rc_quotation.amount / rc_quotation.payment_frequency);

  //   return parseFloat(
  //     rcTotalAmount + primaGuaranteesPrices + risksTotalAmount + servicePrice + (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation)),
  //   ).toFixed(2);
  // };

  const getTotal = () => {
    let rcTotalAmount = 0;
    let primaGuaranteesPrices = 0;
    let risksTotalAmount = 0;
    let servicePrice = 0;

    if (
      insuranceRequest.insurance_request_extra_services.length > 0
    ) {
      insuranceRequest.insurance_request_extra_services.forEach((service) => {
        // servicePrice += parseFloat(calculateExtraServicePrice(rc_quotation, service));
        servicePrice += parseFloat(service.total_price);
      });
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];
        // risksTotalAmount += rc_quotation.payment_frequency === 1 ? parseFloat(item.amount) : parseFloat(item.amount / rc_quotation.payment_frequency);

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    if (rc_quotation.company_id === 2) {
      rc_quotation.guarantees.forEach((guarantee) => {
        // primaGuaranteesPrices += rc_quotation.payment_frequency === 1 ? parseFloat(guarantee.amount) : parseFloat(guarantee.amount / rc_quotation.payment_frequency) || 0;

        primaGuaranteesPrices += parseFloat(guarantee.amount);
      });
    }

    // rcTotalAmount = rc_quotation.payment_frequency === 1 ? parseFloat(rc_quotation.amount) : parseFloat(rc_quotation.amount / rc_quotation.payment_frequency);

    rcTotalAmount = parseFloat(rc_quotation.amount);

    // return parseFloat(
    //   rcTotalAmount + primaGuaranteesPrices + risksTotalAmount + servicePrice + (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation)),
    // ).toFixed(2);

    return parseFloat(
      rcTotalAmount + primaGuaranteesPrices + risksTotalAmount + servicePrice + rc_quotation.brokerage_amount,
    ).toFixed(2);
  };

  return (
    <>
      <BoxWrapper>
        <InfoBoxGrid>
          <InfoCard className="documents-status-step-one pagament-status-step-one">
            <InfoCardHeader>
              <InfoCardTitle>Riepilogo</InfoCardTitle>
              <StatusPill>{statues.find((st) => st.id === quoteStatus).name}</StatusPill>
            </InfoCardHeader>
            <DetailGrid>
              <DetailItem className="full">
                <dt>Cliente</dt>
                <dd>
                  {insuranceRequest.customer.gender !== 'G'
                    ? `${insuranceRequest.customer.name} ${insuranceRequest.customer.surname}`
                    : insuranceRequest.customer.business_name}
                </dd>
              </DetailItem>
              <DetailItem className="full">
                <dt>Veicolo</dt>
                <dd>{insuranceRequest.vehicle.version.full_description}</dd>
              </DetailItem>
              <DetailItem>
                <dt>Targa</dt>
                <dd>{insuranceRequest.vehicle.vehicle_plate}</dd>
              </DetailItem>
              <DetailItem>
                <dt>Decorrenza</dt>
                <dd>
                  {new Date(
                    insuranceRequest.policy_effective_date,
                  ).toLocaleDateString('it-IT')}
                </dd>
              </DetailItem>
              <DetailItem className="full">
                <dt>Tipo Di Guida</dt>
                <dd>
                  {
                    guideType.find((v) => v.id === insuranceRequest.guide_type)
                      .name
                  }
                </dd>
              </DetailItem>
            </DetailGrid>

            <SectionLabel>Documenti</SectionLabel>
            <DocChips>
              {/* <h6
                className="mt-2 text-decoration-underline"
                style={{ cursor: 'pointer' }}
                onClick={() => (rc_quotation.company_id === 1
                  ? downloadResourceDocs(
                    rc_quotation.product_id == 1 ? 1 : 5,
                    0,
                  )
                  : downloadResourceDocs(
                    rc_quotation.product_id == 1 ? 6 : 7,
                    0,
                  ))}
              >
                Informazioni Precontrattuali RCA
              </h6> */}
              {rc_quotation.company_id === 1 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    1,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}

              {rc_quotation.company_id === 1 && rc_quotation.product_id === 3 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    5,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}

              {rc_quotation.company_id === 2 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => {
                    let id = 6;

                    if (rc_quotation.quotation_data_prima && rc_quotation.quotation_data_prima.issuing_company === 'triglav') {
                      id = 34;
                    }

                    if (rc_quotation.quotation_data_prima && rc_quotation.quotation_data_prima.issuing_company === 'great_lakes') {
                      id = 31;
                    }

                    downloadResourceDocs(
                      id,
                      0,
                    );
                  }}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 17 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    18,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 18 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    19,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 1000 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    30,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 1001 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    43,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 17 && rc_quotation.product_id === 3 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    20,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 2 && rc_quotation.product_id === 3 && (
                <DocChip
                  type="button"
                  onClick={() => {
                    let id = 7;

                    if (rc_quotation.quotation_data_prima && rc_quotation.quotation_data_prima.issuing_company === 'triglav') {
                      id = 35;
                    }

                    if (rc_quotation.quotation_data_prima && rc_quotation.quotation_data_prima.issuing_company === 'great_lakes') {
                      id = 32;
                    }

                    downloadResourceDocs(
                      id,
                      0,
                    );
                  }}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 18 && rc_quotation.product_id === 3 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    29,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}

              {rc_quotation.company_id === 9 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    17,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 9 && rc_quotation.product_id === 3 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    50,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {insuranceRequest.insurance_request_extra_services
                && insuranceRequest.insurance_request_extra_services.some(
                  (service) => service.service_name === 'Car Rescue 30',
                ) && (
                  <DocChip
                    type="button"
                    onClick={() => downloadResourceDocs(
                      56,
                      0,
                    )}
                  >
                    Informazioni Precontrattuali Car Rescue 30
                  </DocChip>
              )}
              {insuranceRequest.insurance_request_extra_services
                && insuranceRequest.insurance_request_extra_services.some(
                  (service) => service.service_name === 'Extra Rescue 50',
                ) && (
                  <DocChip
                    type="button"
                    onClick={() => downloadResourceDocs(
                      57,
                      0,
                    )}
                  >
                    Informazioni Precontrattuali Extra Rescue 50
                  </DocChip>
              )}

              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 16)
                !== undefined && (
                  <DocChip
                    type="button"
                    onClick={() => downloadResourceDocs(13)}
                  >
                    Informazioni Precontrattuali Global Assistance
                  </DocChip>
              )}
              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 8)
                !== undefined && (
                  <DocChip type="button" onClick={() => downloadResourceDocs(14)}>
                    Informazioni Precontrattuali Europe Assistance
                  </DocChip>
              )}
              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 1001)
                !== undefined && (
                  <DocChip type="button" onClick={() => downloadResourceDocs(55)}>
                    Informazioni Precontrattuali Nobis Assicurazioni
                  </DocChip>
              )}
              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 1005 && q.quote_type === 'tutela_legale')
                !== undefined && (
                  <DocChip type="button" onClick={() => downloadResourceDocs(60)}>
                    Informazioni Precontrattuali My Rescue - Tutela Legale
                  </DocChip>
              )}
              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 1005 && q.quote_type === 'kasko_collisione')
                !== undefined && (
                  <DocChip type="button" onClick={() => downloadResourceDocs(61)}>
                    Informazioni Precontrattuali My Rescue - Collisione
                  </DocChip>
              )}
              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 1005 && q.quote_type === 'assistenza_stradale')
                !== undefined && (
                  <DocChip type="button" onClick={() => downloadResourceDocs(62)}>
                    Informazioni Precontrattuali My Rescue - Assistenza Stradale
                  </DocChip>
              )}

              {rc_quotation.company_id === 1010 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    58,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              {rc_quotation.company_id === 1011 && rc_quotation.product_id === 1 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    59,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RCA
                </DocChip>
              )}
              <DocChip type="button" onClick={() => downloadPreventive()}>
                Preventivo
              </DocChip>
            </DocChips>

            <ActionRow>
              {rc_quotation.link_to_endpoint && (
                <PrimaryActionLink
                  href={rc_quotation.link_to_endpoint}
                  target="_blank"
                  rel="noreferrer"
                >
                  Paga Ora
                </PrimaryActionLink>
              )}
              <PrimaryActionButton
                type="button"
                onClick={() => downloadDocument(DDF_document.id)}
              >
                Scarica Documento Da Firmare
              </PrimaryActionButton>
            </ActionRow>
          </InfoCard>

          <ProductsTableCard
            className="documents-status-step-two pagament-status-step-two"
            total={getTotal()}
          >
            <tr>
              <td>{rc_quotation.product.name}</td>
              <td>
                {rc_quotation.company_id !== null
                  ? rc_quotation.company.name
                  : rc_quotation.preventivas_company.company_name}
              </td>

              {/* <td>
                {rc_quotation.payment_frequency === 1
                  ? parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                  : parseFloat(
                    (rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)}
                {' '}
                &euro;
              </td> */}
              <td>
                {parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {rc_quotation !== null
              && rc_quotation.company_id === 2
              && rc_quotation.guarantees.map((guarantee, index) => (
                <tr key={index}>
                  <td>
                    {
                      primaQuoteTypes.find(
                        (type) => type.id === guarantee.guarantees_slug,
                      ).name
                    }
                  </td>
                  <td>Prima.it</td>
                  <td>
                    {' '}
                    {/* {rc_quotation.payment_frequency === 1
                      ? parseFloat(guarantee.amount).toFixed(2)
                      : parseFloat(
                        guarantee.amount
                        / rc_quotation.payment_frequency,
                      ).toFixed(2)} */}
                    {parseFloat(guarantee.amount).toFixed(2)}
                    {' '}
                    €
                  </td>
                </tr>
              ))}
            {risk_quotations
              && risk_quotations.map((quote, index) => (
                <tr key={index}>
                  <td>
                    {
                      quoteTypes.find(
                        (type) => type.id === quote.quote_type,
                      ).name
                    }
                    {' '}
                    {quote.company_id === 1005 && quote.product_id === 1
                      && (
                        <>
                          (Servizio non assicurativo)
                        </>
                      )}
                  </td>
                  <td>{quote.company.name}</td>
                  <td>
                    {/* {quote.payment_frequency === 1
                      ? parseFloat(quote.amount).toFixed(2)
                      : parseFloat(
                        quote.amount / quote.payment_frequency,
                      ).toFixed(2)} */}
                    {parseFloat(quote.amount).toFixed(2)}
                    {' '}
                    &euro;
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                Brokeraggio
                {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) && <span className="text-success fw-bold"> (Pagato)</span>}
              </td>
              <td />
              <td>
                {/* {parseFloat(getBrokeragePerPayment(rc_quotation)).toFixed(2)} */}
                {parseFloat(rc_quotation.brokerage_amount).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            <tr>
              <td>Spese Di Emissione</td>
              <td />
              <td>
                {/* {rc_quotation.payment_frequency === 1
                  ? parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                  : parseFloat(
                    (parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)} */}
                {parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {insuranceRequest.insurance_request_extra_services && insuranceRequest.insurance_request_extra_services.length > 0
              && insuranceRequest.insurance_request_extra_services.map((service, index) => (
                <tr key={index}>
                  <td>Servizio Assistenza Stradale</td>
                  <td />
                  <td>
                    {/* {calculateExtraServicePrice(rc_quotation, service)} */}
                    {parseFloat(service.total_price).toFixed(2)}
                    €
                  </td>
                </tr>
              ))}

          </ProductsTableCard>
        </InfoBoxGrid>
      </BoxWrapper>
      {/* <MessagesModal
        {...messagesModalData}
        threads={insuranceRequest.threads}
      /> */}
    </>
  );
}

export default InfoBoxAuto;
